<template>
    <div>
        <div v-if="coach.type && coach.type.system_name === 'coach'" class="website-info-content">
            <b-tabs class="website-info-tabs">
                <b-tab class="mt-3" title="Informatie voor op de website" active>
                    <div class="col-md-12">
                        <div class="row form-group">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                        {{ uLang('app.show_on_website') }}
                                    </label>
                                    <div class="col-md-9 col-xl-10 col-sm-12 d-flex align-items-center">
                                        <span>{{ coach.show_on_website ? uLang('app.yes') : uLang('app.no') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                        {{ uLang('app.title') }}
                                    </label>
                                    <div class="col-md-9 col-xl-10 col-sm-12 d-flex align-items-center">
                                        <span v-if="coach.coach_title">{{ coach.coach_title }}</span>
                                        <span v-else class="text-muted">{{ uLang('app.no_information_available') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                        {{ uLang('app.what_can_you_expect_from_me') }}
                                    </label>
                                    <div class="col-md-9 col-xl-10 col-sm-12">
                                        <div v-if="coach.content" class="content-display" v-html="coach.content"></div>
                                        <span v-else class="text-muted">{{ uLang('app.no_information_available') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                        {{ uLang('app.webtext2') }}
                                    </label>
                                    <div class="col-md-9 col-xl-10 col-sm-12">
                                        <div v-if="coach.webtext2" class="content-display" v-html="coach.webtext2"></div>
                                        <span v-else class="text-muted">{{ uLang('app.no_information_available') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab class="mt-3" title="Overige info">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                            {{ uLang('app.is_ecoaching') }}
                                        </label>
                                        <div class="col-md-9 col-xl-10 col-sm-12 d-flex align-items-center">
                                            <span v-if="coach.is_ecoaching !== null && coach.is_ecoaching !== undefined && coach.is_ecoaching !== ''">
                                                {{ Number(coach.is_ecoaching) === 1 ? 'Doet aan E-Coaching' : 'Doet niet aan E-Coaching' }}
                                            </span>
                                            <span v-else class="text-muted">{{ uLang('app.no_information_available') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group" v-if="coach.department">
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">
                                            {{ uLang('app.department') }}
                                        </label>
                                        <div class="col-md-9 col-xl-10 col-sm-12 d-flex align-items-center">
                                            <span>{{ coach.department }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab class="mt-3" :title="uLang('app.website_trajectories')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <table class="website-info-table table table-striped">
                                        <thead>
                                        <tr>
                                            <th>{{ uLang('app.website_trajectories') }}</th>
                                            <th>{{ uLang('app.specialist') }}</th>
                                            <th>{{ uLang('app.expert') }}</th>
                                            <th>{{ uLang('app.none') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="coach_values.trajectories !== null">
                                        <tr v-for="trajectory in trajectories" :key="trajectory.id">
                                            <td>{{ trajectory.value }}</td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.trajectories[trajectory.id] && coach_values.trajectories[trajectory.id].specialist == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.trajectories[trajectory.id] && coach_values.trajectories[trajectory.id].expert == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.trajectories[trajectory.id] && coach_values.trajectories[trajectory.id].no == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td colspan="4" class="text-center text-muted">{{ uLang('app.no_information_available') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab class="mt-3" :title="uLang('app.website_services')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <table class="website-info-table table table-striped">
                                        <thead>
                                        <tr>
                                            <th>{{ uLang('app.website_services') }}</th>
                                            <th>{{ uLang('app.specialist') }}</th>
                                            <th>{{ uLang('app.expert') }}</th>
                                            <th>{{ uLang('app.none') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="coach_values.services !== null">
                                        <tr v-for="service in services" :key="service.id">
                                            <td>{{ service.value }}</td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.services[service.id] && coach_values.services[service.id].specialist == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.services[service.id] && coach_values.services[service.id].expert == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.services[service.id] && coach_values.services[service.id].no == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td colspan="4" class="text-center text-muted">{{ uLang('app.no_information_available') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab class="mt-3" :title="uLang('app.website_target_audiences')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <table class="website-info-table table table-striped">
                                        <thead>
                                        <tr>
                                            <th>{{ uLang('app.website_target_audiences') }}</th>
                                            <th>{{ uLang('app.specialist') }}</th>
                                            <th>{{ uLang('app.expert') }}</th>
                                            <th>{{ uLang('app.none') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="coach_values.target_audiences !== null">
                                        <tr v-for="target_audience in target_audiences" :key="target_audience.id">
                                            <td>{{ target_audience.value }}</td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.target_audiences[target_audience.id] && coach_values.target_audiences[target_audience.id].specialist == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.target_audiences[target_audience.id] && coach_values.target_audiences[target_audience.id].expert == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.target_audiences[target_audience.id] && coach_values.target_audiences[target_audience.id].no == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td colspan="4" class="text-center text-muted">{{ uLang('app.no_information_available') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab class="mt-3" :title="uLang('app.website_branches')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <table class="website-info-table table table-striped">
                                        <thead>
                                        <tr>
                                            <th>{{ uLang('app.website_branches') }}</th>
                                            <th>{{ uLang('app.specialist') }}</th>
                                            <th>{{ uLang('app.expert') }}</th>
                                            <th>{{ uLang('app.none') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="coach_values.branches !== null">
                                        <tr v-for="branch in branches" :key="branch.id">
                                            <td>{{ branch.value }}</td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.branches[branch.id] && coach_values.branches[branch.id].specialist == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.branches[branch.id] && coach_values.branches[branch.id].expert == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                            <td class="text-center">
                                                <i class="fa" :class="coach_values.branches[branch.id] && coach_values.branches[branch.id].no == 1 ? 'fa-check text-success' : ''"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td colspan="4" class="text-center text-muted">{{ uLang('app.no_information_available') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
<script>


export default {
    name: "WebsiteInfoTab",

    components: {},

    props: {
        coach: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            trajectories: {},
            branches: {},
            services: {},
            target_audiences: {},
            coach_values: {
                trajectories: {},
                branches: {},
                services: {},
                target_audiences: {}
            }
        }
    },

    computed: {},
    mounted() {
        this.coach_values.trajectories = this.coach.trajectories ? JSON.parse(this.coach.trajectories) : null
        this.coach_values.branches = this.coach.branches ? JSON.parse(this.coach.branches) : null
        this.coach_values.services = this.coach.services ? JSON.parse(this.coach.services) : null
        this.coach_values.target_audiences = this.coach.target_audiences ? JSON.parse(this.coach.target_audiences) : null
        this.getSettingValues('website_target_audiences')
        this.getSettingValues('website_branches')
        this.getSettingValues('website_services')
        this.getSettingValues('website_trajectories')
    },

    methods: {
        async getSettingValues(settingName, removableString = 'website_') {
            const {data} = await window.axios.get(route('settings.values.index', {setting: settingName}));

            this[settingName.substring(removableString.length)] = data
        },
    },
}
</script>
<style lang="css" scoped>
.website-info-card {
    margin-top: 40px;
    margin-bottom: 20px;
}

.website-info-card > .card-header {
    margin: 0;
}

th {
    text-align: center;
}

.website-info-table > tr > th {
    min-width: 75px;
}

.content-display {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    padding: 0.75rem;
    background-color: #f8f9fa;
    min-height: 2.5rem;
}

.content-display p {
    margin-bottom: 0;
}

.content-display:empty::before {
    content: attr(data-placeholder);
    color: #6c757d;
    font-style: italic;
}

.table > tbody > tr > td > i {
    display: inline-block;
    width: 100%;
    text-align: center;
}
</style>
